// extracted by mini-css-extract-plugin
export default {"betaBadge":"betaBadge__LMeoI","isBeta":"isBeta__KI0ce","isClosedBeta":"isClosedBeta__XeCyq","isOpenBeta":"isOpenBeta__D18of"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"betaBadge\":\"betaBadge__LMeoI\",\"isBeta\":\"isBeta__KI0ce\",\"isClosedBeta\":\"isClosedBeta__XeCyq\",\"isOpenBeta\":\"isOpenBeta__D18of\"}";
        // 1787130556862
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  